export default __webpack_public_path__ + "static/media/icon_urheilutoiminta_valmis.b09cb48b.svg";